import {
    DEALERBLOCKDSRMASTER_FAILED,
    DEALERBLOCKDSRMASTER_SUCCESS,
    RESET_DEALERBLOCKDSRMASTER,
    LOADING_DEALERBLOCKDSRMASTER,
    NETWORK_ERROR_DEALERBLOCKDSRMASTER
} from '../types/index'


const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERBLOCKDSRMASTER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERBLOCKDSRMASTER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERBLOCKDSRMASTER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERBLOCKDSRMASTER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERBLOCKDSRMASTER:
            return (state = initialState);
        default:
            return state;
    }
};